import { defineMessages } from 'react-intl';

/** The copy of "Upload bio to Spotify" (the bio card, the bio tool and its sheet). */
export const spotifyBioMessages = defineMessages({
  button: { id: 'app.sml.promote.profile.spotifyBio.button', defaultMessage: 'Upload bio to Spotify' },
  buttonShort: { id: 'app.sml.promote.profile.spotifyBio.buttonShort', defaultMessage: 'Upload to Spotify' },
  title: { id: 'app.sml.promote.profile.spotifyBio.title', defaultMessage: 'Upload bio to Spotify' },
  what: {
    id: 'app.sml.promote.profile.spotifyBio.what',
    defaultMessage: 'Your long bio goes to the Spotify page of {artist}.',
  },
  rightsTick: {
    id: 'app.sml.promote.profile.spotifyBio.rightsTick',
    defaultMessage: 'I have all the legal rights to this bio and its links',
  },
  rightsOnce: { id: 'app.sml.promote.profile.spotifyBio.rightsOnce', defaultMessage: 'We ask once per artist.' },
  send: { id: 'app.sml.promote.profile.spotifyBio.send', defaultMessage: 'Send bio to Spotify' },
  sendBusy: { id: 'app.sml.promote.profile.spotifyBio.sendBusy', defaultMessage: 'Sending…' },
  replaces: {
    id: 'app.sml.promote.profile.spotifyBio.replaces',
    defaultMessage: 'It replaces the bio on your Spotify page now.',
  },
  onSince: { id: 'app.sml.promote.profile.spotifyBio.onSince', defaultMessage: 'Bio on Spotify since {date}' },
  changedSince: {
    id: 'app.sml.promote.profile.spotifyBio.changedSince',
    defaultMessage: 'You changed the bio after the Spotify upload of {date}',
  },
  doneConfirmed: {
    id: 'app.sml.promote.profile.spotifyBio.done.confirmed',
    defaultMessage: 'Your bio is on Spotify now.',
  },
  doneUnconfirmed: {
    id: 'app.sml.promote.profile.spotifyBio.done.unconfirmed',
    defaultMessage: 'Spotify took your bio. It can take a few minutes before your Spotify page shows it.',
  },
  nothing: {
    id: 'app.sml.promote.profile.spotifyBio.nothing',
    defaultMessage: 'Write and save the long bio first. Then send it to Spotify.',
  },
  rightsRequired: {
    id: 'app.sml.promote.profile.spotifyBio.rightsRequired',
    defaultMessage: 'Tick the line about the legal rights first.',
  },
  tooLong: {
    id: 'app.sml.promote.profile.spotifyBio.tooLong',
    defaultMessage: 'The long bio is longer than 1500 characters. Cut it, save it, then send it.',
  },
  noPermission: {
    id: 'app.sml.promote.profile.spotifyBio.noPermission',
    defaultMessage:
      'Your Spotify for Artists role cannot change the profile of {artist}. Ask an admin of the team for the Editor role.',
  },
  refused: {
    id: 'app.sml.promote.profile.spotifyBio.refused',
    defaultMessage: 'Spotify did not take the bio. Spotify said: "{detail}"',
  },
  refusedNoDetail: {
    id: 'app.sml.promote.profile.spotifyBio.refusedNoDetail',
    defaultMessage: 'Spotify did not take the bio. Change it and try again.',
  },
  failed: {
    id: 'app.sml.promote.profile.spotifyBio.failed',
    defaultMessage: 'We could not reach Spotify. Try again.',
  },
  generic: { id: 'app.sml.promote.profile.spotifyBio.generic', defaultMessage: 'That did not work. Try again.' },
  whereNoteUpload: {
    id: 'app.sml.promote.profile.bio.where.noteUpload',
    defaultMessage: 'Or save the long bio and use Upload bio to Spotify: MUSIC24 sends it for you.',
  },
});
